import { render, staticRenderFns } from "./IconColumns.vue?vue&type=template&id=5ce7e2f2&scoped=true&lang=pug"
import script from "./IconColumns.vue?vue&type=script&lang=js"
export * from "./IconColumns.vue?vue&type=script&lang=js"
import style0 from "./IconColumns.vue?vue&type=style&index=0&id=5ce7e2f2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce7e2f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/andrewatieh/WebstormProjects/JTCoffeeTheme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ce7e2f2')) {
      api.createRecord('5ce7e2f2', component.options)
    } else {
      api.reload('5ce7e2f2', component.options)
    }
    module.hot.accept("./IconColumns.vue?vue&type=template&id=5ce7e2f2&scoped=true&lang=pug", function () {
      api.rerender('5ce7e2f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/icon-columns/IconColumns.vue"
export default component.exports